import { DocumentTaskRequestClient } from "../../../../Wrap/Api/Tasks/DocumentTaskRequest";
import { TaskRequestStatusClient } from "../../../../Wrap/Api/Tasks/TaskRequestStatus";
import { DocumentTaskRequestModel } from "../../../../Wrap/Models/Models/Tasks/DocumentTaskRequestModel";

export class DownloadButtonAction {
    public static getTaskRequestStatus(taskRequestId: string, callback): void {
        const client = new TaskRequestStatusClient();
        const promise = client.get(taskRequestId);
        promise.onSuccess((res) => {
            callback(res);
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static addTaskRequestForDocument(query: DocumentTaskRequestModel, callback): void {
        const client = new DocumentTaskRequestClient();
        const promise = client.post(query);
        promise.onSuccess((res) => {
            callback(res);
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
